import * as React from 'react';
import { TCheckoutProgress } from './CheckoutProgress.types';
import './CheckoutProgress.styled.scss';
import { CHECKOUT_STEPS } from '../../Checkout.constants';
import { TCheckoutStep } from '../../Checkout.types';

export const CheckoutProgress: TCheckoutProgress = ({ currentStep }) => {
  const currentStepIndex = CHECKOUT_STEPS.findIndex(
    (step) => step.id === currentStep
  );
  const progress = ((currentStepIndex + 1) / CHECKOUT_STEPS.length) * 100;

  return (
    <div className="checkout-progress">
      <div className="checkout-progress__bar">
        <div
          className="checkout-progress__bar-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="checkout-progress__steps">
        {CHECKOUT_STEPS.map((step, index) => {
          const isActive = step.id === currentStep;
          const isCompleted = index < currentStepIndex;
          return (
            <div
              key={step.id}
              className={`checkout-progress__step ${
                isActive ? 'checkout-progress__step--active' : ''
              } ${isCompleted ? 'checkout-progress__step--completed' : ''}`}
            >
              <div className="checkout-progress__step-number">
                {isCompleted ? '✓' : step.step}
              </div>
              <span className="checkout-progress__step-label">
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
